import {NgModule} from '@angular/core';
import {CauseCoreModule} from '@cause-911/core';
import {SocialNetworkComponent} from './social-network.component';

@NgModule({
    declarations: [
        SocialNetworkComponent
    ],
    exports: [
        SocialNetworkComponent
    ],
    imports: [
        CauseCoreModule,
    ],
})
export class SocialNetworkModule {
}
